const submitButton = document.getElementById('Form_ProfileForm_action_save')

if (submitButton) {
  // If changing this, make sure it's changed in the frontend located in app/src/extensions/PhoneValidationExtension.php
  const pattern = /^(((\+?64\s*[-.]?[3-9]|\(?0[3-9]\)?)\s*[-.]?\d{3}\s*[-.]?\d{4})|((\+?64\s*[-.(]?2\d{1}[-.)]?|\(?02\d{1}\)?)\s*[-.]?\d{3}\s*[-.]?\d{3,5})|((\+?64\s*[-.]?[-.(]?800[-.)]?|[-.(]?0508[-.)]?|[-.(]?0800[-.)]?)\s*[-.]?\d{3}\s*[-.]?(\d{3,4}|\d{6,7})))$/
  const mobileNumberValidation = function (e) {
    const fieldsToValidate = ['MobileNumber', 'AlternativeNumber', 'SecondaryContactMobileNumber', 'SecondaryContactAlternativeNumber']
    var errors = false
    fieldsToValidate.forEach((field) => {
      var fieldElement = document.getElementById('Form_ProfileForm_' + field)

      var number = fieldElement.value
      number = number.replace(/-/g, '').replace(/\D/g, '').replace(')', '').replace('(', '').replace('+', '')
      fieldElement.parentElement.classList.remove('holder-bad')
      fieldElement.parentElement.classList.remove('invalid-phone-number-message')

      if (fieldElement.value.length > 0 && !pattern.test(number)) {
        e.preventDefault()
        errors = true
        fieldElement.parentElement.classList.add('holder-bad')
        fieldElement.parentElement.classList.add('invalid-phone-number-message')
      }
    })
    if (errors) {
      const element = document.getElementsByClassName('holder-bad')
      element[0].scrollIntoView({ behavior: 'smooth' })
    }
  }
  submitButton.addEventListener('click', mobileNumberValidation)
}
